import React, { useEffect, useState } from "react";
import { adminSystem } from "../../adminApi";
import { Server, Loader2 } from "lucide-react";

export default function AdminSystem() {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => { try { setInfo(await adminSystem()); } finally { setLoading(false); } })(); }, []);

  return (
    <div>
      <h2 className="text-2xl font-extrabold text-gray-900 mb-1 flex items-center gap-2"><Server className="w-6 h-6" /> Sistema</h2>
      <p className="text-sm text-gray-500 mb-5">Estado del servidor y configuración.</p>

      {loading ? (
        <p className="text-gray-500"><Loader2 className="w-5 h-5 animate-spin inline" /> Cargando...</p>
      ) : info ? (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div>
              <dt className="text-gray-500 text-xs uppercase tracking-wider">Python</dt>
              <dd className="font-semibold text-gray-900">{info.python}</dd>
            </div>
            <div>
              <dt className="text-gray-500 text-xs uppercase tracking-wider">Plataforma</dt>
              <dd className="font-semibold text-gray-900 break-all">{info.platform}</dd>
            </div>
            <div>
              <dt className="text-gray-500 text-xs uppercase tracking-wider">Hora actual</dt>
              <dd className="font-semibold text-gray-900">{new Date(info.now).toLocaleString("es-DO")}</dd>
            </div>
            <div>
              <dt className="text-gray-500 text-xs uppercase tracking-wider">Scheduler</dt>
              <dd>
                <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${info.scheduler_running ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-800"}`}>
                  {info.scheduler_running ? "Corriendo" : "Detenido"}
                </span>
              </dd>
            </div>
            <div className="sm:col-span-2">
              <dt className="text-gray-500 text-xs uppercase tracking-wider">Admins</dt>
              <dd className="font-mono text-xs text-gray-900">{(info.admin_emails || []).join(", ")}</dd>
            </div>
          </dl>
        </div>
      ) : (
        <p className="text-red-600">Error cargando datos.</p>
      )}
    </div>
  );
}
